import {useEffect} from 'react';
import {appointmentActions} from 'features/Appointment';
import {notificationActions} from 'features/Notification';
import {userActions} from 'features/User';
import {
  Appointment,
  CurrentUser,
  MemberProfile,
  PrescriberProfile,
  SocketEvents,
  TherapistProfile,
  TNotification,
} from 'interfaces';
import {useDispatch} from 'react-redux';
import {isProvider} from 'utils';
import {getSocket} from 'utils/socketClient';

export function useSocket(user: CurrentUser) {
  const dispatch = useDispatch();

  const userId =
    (user as MemberProfile)?.patientId ||
    (user as PrescriberProfile)?.prescriberId ||
    (user as TherapistProfile)?.therapistId;

  const _isProvider = isProvider(user);

  useEffect(() => {
    if (!userId) return;

    const socket = getSocket();

    socket.on('connect', () => {
      console.log('ws: connected');
      socket.emit(SocketEvents.JOIN, userId);
    });

    socket.on(SocketEvents.NEW_NOTIFICATION, (data: TNotification) => {
      if (
        data.notificationType === 'session_rate_change' &&
        data.notification?.data
      ) {
        dispatch(
          userActions.updateDpProvidersSessionRateForMember({
            sessionRate: data.notification.data.newRate!,
            providerId: data.notification.data.providerId!,
            providerRole: data.notification.data.providerRole!,
          }),
        );
      }

      dispatch(
        notificationActions.notificationReceived({
          notification: data,
          notificationType: data.notificationType,
        }),
      );
    });

    socket.on(SocketEvents.SYNC_APPOINTMENT, (data: Appointment) => {
      if (_isProvider && data.canceled) {
        dispatch(appointmentActions.removeAppointment(data));
      } else {
        dispatch(appointmentActions.addAppointment(data));
      }
    });

    return () => {
      // Important: don't disconnect the singleton on unmount
      socket.off(SocketEvents.NEW_NOTIFICATION);
      socket.off(SocketEvents.SYNC_APPOINTMENT);
      socket.off('connect');
    };
  }, [userId]);
}
